// Read & Paint — Global JS

// Mobile menu toggle
document.addEventListener('DOMContentLoaded', () => {
  const menuToggle = document.querySelector('.header__menu-toggle');
  const mobileNav = document.querySelector('.header__mobile-nav');

  if (menuToggle && mobileNav) {
    menuToggle.addEventListener('click', () => {
      const isOpen = mobileNav.classList.toggle('is-open');
      menuToggle.setAttribute('aria-expanded', isOpen);
      document.body.classList.toggle('menu-open', isOpen);
    });
  }

  // Close mobile nav on link click
  document.querySelectorAll('.header__mobile-nav a').forEach(link => {
    link.addEventListener('click', () => {
      mobileNav?.classList.remove('is-open');
      menuToggle?.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('menu-open');
    });
  });

  // Sticky header shadow
  const header = document.querySelector('.header');
  if (header) {
    const observer = new IntersectionObserver(
      ([entry]) => header.classList.toggle('header--scrolled', !entry.isIntersecting),
      { rootMargin: '-80px 0px 0px 0px' }
    );
    const sentinel = document.createElement('div');
    sentinel.style.cssText = 'position:absolute;top:0;height:1px;width:1px;pointer-events:none;';
    document.body.prepend(sentinel);
    observer.observe(sentinel);
  }

  // Quantity selectors
  document.querySelectorAll('.quantity').forEach(el => {
    const input = el.querySelector('.quantity__input');
    el.querySelector('[data-action="decrease"]')?.addEventListener('click', () => {
      const val = parseInt(input.value) || 1;
      if (val > 1) input.value = val - 1;
    });
    el.querySelector('[data-action="increase"]')?.addEventListener('click', () => {
      input.value = (parseInt(input.value) || 1) + 1;
    });
  });

  // Cart notification auto-dismiss
  const notification = document.querySelector('.cart-notification');
  if (notification) {
    setTimeout(() => notification.classList.add('cart-notification--hidden'), 3000);
  }
});
